var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bill-white-board-main"},[_c('div',{staticClass:"bill-white-board",attrs:{"id":_vm.call.elIds.white_board}},[_c('canvas',{attrs:{"id":_vm.call.elIds.white_board_canvas}})]),(_vm.call.white_board)?_c('ToolBar',{attrs:{"call":_vm.call}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }